import blockquote from './blockquote';
import bulletList from './bulletList';
import date from './date';
import decisionItem from './decisionItem';
import hardBreak from './hardBreak';
import heading from './heading';
import inlineCard from './inlineCard';
import listItem from './listItem';
import mediaGroup from './mediaGroup';
import mention from './mention';
import orderedList from './orderedList';
import panel from './panel';
import paragraph from './paragraph';
import rule from './rule';
import status from './status';
import table from './table';
import taskItem from './taskItem';
import unknown from './unknown';
export var reduce = function reduce(node, schema) {
  var reducer = nodeToReducerMapping[node.type.name] || nodeToReducerMapping.unknown;
  return reducer(node, schema);
};
var nodeToReducerMapping = {
  blockquote: blockquote,
  bulletList: bulletList,
  date: date,
  decisionItem: decisionItem,
  hardBreak: hardBreak,
  heading: heading,
  inlineCard: inlineCard,
  listItem: listItem,
  mediaGroup: mediaGroup,
  mention: mention,
  orderedList: orderedList,
  panel: panel,
  paragraph: paragraph,
  rule: rule,
  status: status,
  table: table,
  taskItem: taskItem,
  unknown: unknown
};